import * as yup from 'yup';


const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
//const websiteRegExp = /^(https?:\/\/)?(?:[a-zA-Z0-9._~!$&'()*+,;=:%-]+(?::[a-zA-Z0-9._~!$&'()*+,;=:%-]+)?@)?(?!-)([a-zA-Z0-9-]{1,63}(?<!-)\.)+[a-zA-Z]{2,}(?::(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]?\d{1,4}))?(?:\/[a-zA-Z0-9._~!$&'()*+,;=:%/-]*)?(?:\?[a-zA-Z0-9._~!$&'()*+,;=:%/-]*)?(?:#[a-zA-Z0-9._~!$&'()*+,;=:%/-]*)?$/;
const websiteRegExp = /^(?!.*\.\.)(https?:\/\/)?(?:[a-zA-Z0-9._~!$&'()*+,;=:%-]+(?::[a-zA-Z0-9._~!$&'()*+,;=:%-]+)?@)?(?!-)([a-zA-Z0-9-]{1,63}(?<!-)\.)+[a-zA-Z]{2,}(?::(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]?\d{1,4}))?(?:\/[a-zA-Z0-9._~!$&'()*+,;=:%/-]*)?(?:\?[a-zA-Z0-9._~!$&'()*+,;=:%/-]*)?(?:#[a-zA-Z0-9._~!$&'()*+,;=:%/-]*)?$/;

const signupV2Validation = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email Address is required')
    .lowercase(),
  password: yup
    .string()
    .matches(/(?=.{8})/, 'Passcode must be at least 8 characters long')
    .matches(
      /(?=^.{0,255}$)/,
      'Passcode must be no more than 255 characters long'
    )
    .matches(/(?=.*[a-z])/, 'Passcode must have at least 1 lower-cased letter')
    .matches(/(?=.*[A-Z])/, 'Passcode must have at least 1 capital letter')
    .matches(/(?=.*[0-9])/, 'Passcode must have at least 1 number')
    .matches(
      /^(?=.*[!@#\$%\^&\*])/,
      'Contains at least one special symbol (e.g., !, @, #, $, %)'
    )
    .required('Passcode is empty'),
  confirmPassword: yup
    .string()
    .required('Confirm Passcode is required')
    .oneOf([yup.ref('password')], 'Passcodes must match'),
  nameFirst: yup
    .string()
    .required('Name: First is required'),
  nameLast: yup
    .string()
    .required('Name: Last is required'),
  company: yup
    .string()
    .required('Company is required'),
  companyTitle: yup
    .string()
    .required('Title is required'),
  addressOne: yup
    .string()
    .required('Address 1: Office is required'),
  emailProfOne: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email 1: Professional Primary is required'),
  telephoneMobile: yup
    .string()
    // .matches(phoneRegExp, 'Please enter a valid mobile/sms number.')
    .required('Telephone: Mobile/SMS is required'),
  companyWebsite: yup
    .string()
    .matches(websiteRegExp, 'Please enter a valid website URL')
    .required('Company Website is required')
});

export default signupV2Validation;
